import { Col, Container, Row } from "reactstrap";
import './Footer.css';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation('footer');

  return(
    <footer className="bg-primary py-3">
      <Container>
        <Row>
          <Col md="6" className="text-white">
            { t('copyright') } &copy; 2026
          </Col>
          <Col md="6" className="text-end">
            <Link to="/about" className="text-white">{ t('about') }</Link>
            {' '}<span className="text-white"> | </span>{' '}
            <Link to="/terms" className="text-white">{ t('terms') }</Link>
            {' '}<span className="text-white"> | </span>{' '}
            <Link to="/privacy" className="text-white">{ t('privacy') }</Link>
            {' '}<span className="text-white"> | </span>{' '}
            <Link to="/contact" className="text-white">{ t('contact') }</Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;